export enum DictCodeEnmu {
    //业务范围
    BUS = "bus",
    //业务资质
    COLUMN ="column"
}